// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tikTGt5owjz_wTTNlmoM {
  border: none !important;
}`, "",{"version":3,"sources":["webpack://./packages/react-hook-schema/standard/src/lib/password.module.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF","sourceRoot":""}]);
// Exports
export var noBorder = `tikTGt5owjz_wTTNlmoM`;
export default ___CSS_LOADER_EXPORT___;
